import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;

    const { 
        MediaUpload,
        RichText,
        InspectorControls,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        IconButton,
        Button,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-family', {
        // built-in attributes
        title: 'Card Family',
        description: 'Custom Card Family',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            logo: {
                type: 'string',
                default: '/wp-content/uploads/White-logo-no-background.png'
            },
            title: {
                type: 'string',
                default: 'Family card'
            },
            percent: {
                type: 'string',
                default: '- 5 %'
            },
            slogan: {
                type: 'string',
                default: 'Come as guests, return as friend'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                logo,
                title,
                percent,
                slogan,
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions
            function onSelectLogo(logo) {
                setAttributes({logo: logo.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onPercentChange(percent) {
                setAttributes({percent: percent});
            }

            function onSloganChange(slogan) {
                setAttributes({slogan: slogan});
            }

            return([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectLogo }
                            type="image"
                            value={ logo } 
                            render={ ( { open } ) => (
                                <div>
                                    { logo && 
                                        <div>
                                            <figure>
                                                <img src={logo} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ logo: '' })} className="button">Remove</Button>
                                            </div>
                                            <br></br>
                                        </div>
                                
                                    }
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Logo Image
                                </IconButton>
                                </div>
                            ) } />
                        <p><strong>Title:</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Percent:</strong></p>
                        <TextControl value={ percent } onChange={ onPercentChange }></TextControl>
                        <br />
                        <p><strong>Slogan:</strong></p>
                        <TextControl value={ slogan } onChange={ onSloganChange }></TextControl>
                        <br />
                    </PanelBody>
                </InspectorControls>
                , 
                <div className={ "card-family" + (classes ? ' ' + classes : '') }>
                    <img class="card-logo" src={ logo } alt="IstriaLux logo" />
                    <RichText 
                        key="editable" 
                        tagName="p"
                        className="card-title"
                        value={ title }
                        onChange={ onTitleChange } />
                    <RichText 
                        key="editable" 
                        tagName="p"
                        className="card-percent"
                        value={ percent }
                        onChange={ onPercentChange } />
                    <RichText 
                        key="editable" 
                        tagName="p"
                        className="card-slogan"
                        value={ slogan }
                        onChange={ onSloganChange } />
                </div>
            ]);
        },

        save({ attributes }) {
            const {
                logo,
                title,
                percent,
                slogan,
                classes
            } = attributes;

            return(
                <div className={ "card-family" + (classes ? ' ' + classes : '') }>
                    <img class="card-logo" src={ logo } alt="IstriaLux logo" />
                    <p className="card-title">{ title }</p>
                    <p className="card-percent">{ percent }</p>
                    <p className="card-slogan">{ slogan }</p>
                </div>
            );
        },

    });

}